// extracted by mini-css-extract-plugin
module.exports = {"input_search_bundle":"SearchInput_input_search_bundle__5z_rL"};